import React from "react";
import { Link } from "react-router-dom";
import { FiGift, FiSmile, FiUsers, FiHome, FiHeart, FiStar, FiBriefcase } from "react-icons/fi";

const eventTypes = [
  { title: "Birthdays", description: "Live now — decor, cakes, catering, and photography for birthdays of any size.", Icon: FiGift, live: true, to: "/packages" },
  { title: "Baby showers", description: "Themed decor and catering for welcoming a new arrival.", Icon: FiSmile, live: false },
  { title: "Small gatherings", description: "Simple, well-styled setups for intimate get-togethers at home.", Icon: FiUsers, live: false },
  { title: "Housewarmings", description: "Decor and catering for settling into a new home.", Icon: FiHome, live: false },
  { title: "Engagements", description: "Styling and catering for the celebration before the wedding.", Icon: FiHeart, live: false },
  { title: "Weddings", description: "End-to-end wedding planning and vendor coordination.", Icon: FiStar, live: false },
  { title: "Corporate events", description: "Conferences, offsites, and company celebrations.", Icon: FiBriefcase, live: false },
];

const Events = () => {
  return (
    <section className="bg-cloud py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Events we plan</h1>
          <p className="mt-4 text-muted">
            We're building Nirkana to cover every kind of gathering.
            Birthdays are live today — everything else here is on our
            roadmap, in the order we're building it.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {eventTypes.map(({ title, description, Icon, live, to }) => (
            <div key={title} className="rounded-2xl border border-line bg-paper p-6">
              <div className="flex items-center justify-between">
                <Icon className="text-action" size={22} />
                {live ? (
                  <span className="rounded-full bg-success/10 px-2.5 py-1 text-[11px] font-semibold text-success">Live</span>
                ) : (
                  <span className="rounded-full bg-brand-soft px-2.5 py-1 text-[11px] font-semibold text-brand">Coming soon</span>
                )}
              </div>
              <h3 className="mt-4 text-base font-semibold text-charcoal">{title}</h3>
              <p className="mt-2 text-sm text-muted">{description}</p>
              {live && to && (
                <Link to={to} className="mt-4 inline-block text-sm font-medium text-action hover:underline">
                  See packages →
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
